export default __webpack_public_path__ + "static/media/sound-wav.6af2b898.mp4";